import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import { FieldType, MediaGroup, UploadMedia } from 'constants/inspections';
import { tipologiaSolettaOptions } from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import SoletteForm from './SoletteForm';
const SoletteSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const mensoleTamponiCampateImpalcatoTableSoletteTableWatch = watch(
    `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].soletteTable`
  );

  // table setup
  const dataConfigSolette = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaSoletta: {
        label: 'Tipologia',
        format: tipologiaSolettaOptions,
      },
      altezzaSpessoreBordoSoletta: {
        label: 'H [cm]',
      },
      lunghezzaSbalzoSoletta: {
        label: 'Ls [cm]',
      },
    },
  };

  // solette setup
  const [selectedSolette, setSelectedSolette] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsSolette = item => {
    setValue('l0t2a5_soletteTableValue', [item]);
    setValue('l0t2a5_tipologiaSoletteTableValue', item.tipologiaSoletta);
    setValue(
      'l0t2a5_altezzaSpessoreBordoSolettaTableValue',
      item.altezzaSpessoreBordoSoletta
    );
    setValue(
      'l0t2a5_lunghezzaSbalzoSolettaTableValue',
      item.lunghezzaSbalzoSoletta
    );
  };
  const handleSelectAllClickSolette = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].soletteTable`
      );
      setSelectedSolette(selectedValue);
      setValue('l0t2a5_soletteTableValue', selectedValue);
    } else {
      setSelectedSolette([]);
      setValue('l0t2a5_soletteTableValue', []);
    }
  };

  return (
    <>
      <GridWrap container spacing={2} style={{ marginTop: 16 }}>
        <InfoWrapper
          isDivider={true}
          size={12}
          infoDrawer={true}
          drawerTitle={INFO.impalcatoSolette.drawerTitle}
          drawerText={INFO.impalcatoSolette.drawerText}
        >
          <Divider>SOLETTE</Divider>
        </InfoWrapper>
        {mensoleTamponiCampateImpalcatoTableSoletteTableWatch?.length === 0 && (
          <GridWrap item xs={12} paddingTop={'0px !important'}>
            <Typography>Nessuna soletta presente in questo elemento</Typography>
          </GridWrap>
        )}
      </GridWrap>
      {mensoleTamponiCampateImpalcatoTableSoletteTableWatch?.length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <SoletteForm
              soletteFields={
                mensoleTamponiCampateImpalcatoTableSoletteTableWatch || []
              }
              selected={selectedSolette}
              setSelected={setSelectedSolette}
              soletteTable={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].soletteTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Solette'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].soletteTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Struttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={
                  mensoleTamponiCampateImpalcatoTableSoletteTableWatch || []
                }
                config={dataConfigSolette}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsSolette(item);
                            setSelectedSolette([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        mensoleTamponiCampateImpalcatoTableSoletteTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedSolette}
                onSelectAllClick={handleSelectAllClickSolette}
                setSelected={setSelectedSolette}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
SoletteSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default SoletteSection;
